import { MSPTOOLS_API } from "@/config/apis";
import axios from "axios";

const _basicHeaders = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
};

const loadHistoricalData = async parameters => {
  const url = `${MSPTOOLS_API.url}/${MSPTOOLS_API.historicalData.path}`;

  const res = await axios.post(url, parameters, {
    headers: _basicHeaders
  });
  return res;
};

const getBiologicalSuitability = async parameters => {
  const url = `${MSPTOOLS_API.url}/${MSPTOOLS_API.biological.path}`;

  const res = await axios.post(url, parameters, {
    headers: _basicHeaders
  });
  return res;
};

const getWaveEnergySuitability = async parameters => {
  const url = `${MSPTOOLS_API.url}/${MSPTOOLS_API.waveEnergy.path}`;

  const res = await axios.post(url, parameters, {
    headers: _basicHeaders
  });
  return res;
};

const getWindEnergySuitability = async parameters => {
  const url = `${MSPTOOLS_API.url}/${MSPTOOLS_API.windEnergy.path}`;

  const res = await axios.post(url, parameters, {
    headers: _basicHeaders
  });
  return res;
};

export {
  loadHistoricalData,
  getBiologicalSuitability,
  getWaveEnergySuitability,
  getWindEnergySuitability
};
